<template>
    <v-main>
        <v-container fluid>
            <v-row cols="12">
                <v-col cols="12">
                    <tableFaqAccommodation ref="tableFaqAccommodation" />
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';
    import tableFaqAccommodation  from '@/components/syst/openai/tableFaqAccommodation.vue';

    export default {        
        components: {
            navbar,
            tableFaqAccommodation,
        },
        data() {
            return {
            }
        },
        methods: {
            // Dummy callback for navBar
            actionClick() {
            },           
        },
    }
</script>

<style scoped>
</style>
